import { IconProps } from "@/core/global-data/dataInterface.data";

export default function PlusIcon({ width = '25', height = '25', className = '' }: IconProps) {
    return (
        <span className={className}>
            <svg
                width={width || '25'}
                height={height || '25'}
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    opacity="0.4"
                    d="M16.69 2.5H8.31C4.67 2.5 2.5 4.67 2.5 8.31V16.68C2.5 20.33 4.67 22.5 8.31 22.5H16.68C20.32 22.5 22.49 20.33 22.49 16.69V8.31C22.5 4.67 20.33 2.5 16.69 2.5Z"
                    // fill="#145DA0"
                    fill="currentColor"
                />
                <path
                    d="M18.5 11.75H13.25V6.5C13.25 6.09 12.91 5.75 12.5 5.75C12.09 5.75 11.75 6.09 11.75 6.5V11.75H6.5C6.09 11.75 5.75 12.09 5.75 12.5C5.75 12.91 6.09 13.25 6.5 13.25H11.75V18.5C11.75 18.91 12.09 19.25 12.5 19.25C12.91 19.25 13.25 18.91 13.25 18.5V13.25H18.5C18.91 13.25 19.25 12.91 19.25 12.5C19.25 12.09 18.91 11.75 18.5 11.75Z"
                    // fill="#125592"
                    fill="currentColor"
                />
            </svg>
        </span>
    );
}
